var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"validation-errors"},[_c('ul',_vm._l((_vm.errors),function(error,idx){return _c('li',{key:idx},[_vm._v(" "+_vm._s(error.msg)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }